import { useState } from 'react';
import { FaEnvelope, FaExclamationCircle, FaLock } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import CommonButton from '../components/CommonButton';
import CustomFormGroup from '../components/CustomFormGroup';
import { loginMember } from '../redux/authThunks';
import '../styles/Login.css';
import { useLoading } from "../components/LoadingContext";

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [touched, setTouched] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleTogglePassword = () => setShowPassword(prev => !prev);

  const validate = () => {
    const errors = {};
    if (!form.email) errors.email = 'Email is required';
    if (!form.password) errors.password = 'Password is required';
    return errors;
  };

  const errors = validate();
  const isValid = Object.keys(errors).length === 0;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValid) {
      setTouched({ email: true, password: true });
      return;
    }

    showLoading();
    try {
      // dispatch login thunk
      const memberData = await dispatch(loginMember({ email: form.email, password: form.password })).unwrap();

      console.log('Logged in member data:', memberData);

      // navigate hanya setelah login sukses
      navigate('/dashboard');
    } catch (err) {
      setError(err || 'Login gagal');
    } finally {
      hideLoading();
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h2 className="login-title">Login</h2>
        <form onSubmit={handleLogin} noValidate>
          <CustomFormGroup
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email"
            icon={<FaEnvelope />}
            error={touched.email && errors.email}
          />
          <CustomFormGroup
            type={showPassword ? 'text' : 'password'}
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Password"
            icon={<FaLock />}
            togglePassword
            showPassword={showPassword}
            onTogglePassword={handleTogglePassword}
            error={touched.password && errors.password}
          />
          {error && (
            <div className="login-error">
              <FaExclamationCircle /> {error}
            </div>
          )}
          <CommonButton type="submit">Login</CommonButton>
        </form>

        <div className="login-links">
          <Link to="/questioner">Register</Link> | <Link to="/forgot-password">Forgot Password?</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
